import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=19c90b69&scoped=true&"
var script = {}
import style0 from "./TableInfo.vue?vue&type=style&index=0&id=19c90b69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c90b69",
  null
  
)

export default component.exports